import queryString from "query-string";
import { checkUserToken } from "@utils/call-api/auths-call";

function TunnelStepInit() {
  return null;
}

export async function getServerSideProps({ query, req, locale, defaultLocale }) {
  const jwt = req.cookies["jwt-token"];

  const isUserLoggedIn = await checkUserToken(jwt);

  const destinationLocale = locale !== defaultLocale ? `/${locale}` : "";
  const destinationPath = isUserLoggedIn
    ? "/je-commence/ready-to-subscribe"
    : "/je-commence/ready-to-signup";
  const queryStringified = queryString.stringify(query);
  const destination = `${destinationLocale}${destinationPath}${queryStringified ? `?${queryStringified}` : ""}`;

  return {
    redirect: {
      destination,
      permanent: false,
    },
  };
}

TunnelStepInit.requireAuth = false;

export default TunnelStepInit;
